import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CustomFormInput from "../components/CustomFormInput";
import { useLocation, useNavigate } from "react-router-dom";
import { decryptFromStoreLoc } from "../helper/localStorage";
import { PasswordValidateField } from "../validate/password";
import ErrorFilter from "../helper/errorFilter";
import { resetPassword } from "../controller";
import { requestHandler } from "../helper";
import { toast } from "react-toastify";
import SingleError from "../helper/SingleError";

function CreatePassword() {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const handleConfirmPassword = () => {
    setIsConfirmPassword(!isConfirmPassword);
  };

  const navigate = useNavigate();
  const isOtpValidate = decryptFromStoreLoc("isOtpValidate");

  const location = useLocation();
  const email = location.state?.email;
  const requireField = ["confirmpassword", "password"];
  const [submitCount, setSubmitCount] = useState(0);
  const [errors, setErrors] = useState({});
  const [loginData, setLoginData] = useState({
    password: "",
    confirmpassword: "",
  });
  useEffect(() => {
    if (isOtpValidate !== 1) {
      navigate('/');
    }
    // eslint-disable-next-line
  }, [isOtpValidate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
    if (submitCount > 0) {
      let validationErrors = PasswordValidateField({ ...loginData, [name]: value });
      validationErrors = ErrorFilter(validationErrors, requireField);

      if (Object.keys(validationErrors).length === 0) {
        delete errors[name];
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitCount(prevCount => prevCount + 1);
    const updatedValues = { ...loginData };
    let validationErrors = PasswordValidateField(updatedValues);
    validationErrors = ErrorFilter(validationErrors, requireField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      await requestHandler(async () => await resetPassword({ email: email, password: updatedValues.password }),
        null,
        (response) => {
          toast.success(response.message);
          localStorage.clear();
          navigate('/');
        },
        () => { }
      )
    }
  }


  const handleBack = async () => {
    navigate('/');
    localStorage.clear();
  }
  // useEffect(() => {
  //   document.title = "Always Outdoors | Create Password";
  // }, [window.location.pathname])

  return (
    <div className="login-wrapper">
      <div className="container">
        <Row className="justify-content-center">
          <Col xxl={5} xl={6} lg={7} md={9}>
            <div className="login-card">
              <div className="login-logo">
                <img
                  src="/images/svg/logo.svg"
                  className="img-fluid"
                  alt="logo"
                />
              </div>
              <h4>Create New Password</h4>
              <p>Please make, sure, your new password must be unique from previouly used password</p>
              <div className="position-relative">
                <CustomFormInput
                  type={isPasswordVisible ? "text" : "password"}
                  label="Password"
                  placeholder="Enter your password"
                  id="password"
                  name="password"
                  onChange={handleChange}
                  className="password-input"
                />
                <SingleError error={errors.password} />
                <span className="password-icon" onClick={togglePasswordVisibility}>
                  {isPasswordVisible ? <img src="/images/svg/eye-slash.svg" alt="icon" /> : <img src="/images/svg/eye.svg" alt="icon" />}
                </span>
              </div>
              <div className="position-relative">
                <CustomFormInput
                  type={isConfirmPassword ? "text" : "password"}
                  label="Confirm Password"
                  placeholder="Enter your password"
                  id="password"
                  name="confirmpassword"
                  onChange={handleChange}
                  className="password-input"
                />
                <SingleError error={errors.confirmpassword} />
                <span className="password-icon" onClick={handleConfirmPassword}>
                  {isConfirmPassword ? <img src="/images/svg/eye-slash.svg" alt="icon" /> : <img src="/images/svg/eye.svg" alt="icon" />}
                </span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <button type='button' className="btn btn-outline-primary w-100 mt-1" onClick={handleBack}>
                  Back to Login
                </button>
                <button type='button' onClick={handleSubmit} className="btn btn-primary w-100 mt-1">
                  Reset Password
                </button>
              </div>

            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default CreatePassword;
